(function() {
    'use strict';
     angular
        .module('valueconnectApp')
        .factory('Concern', Concern);

    Concern.$inject = ['$resource'];

    function Concern ($resource) {
        var resourceUrl =  'api/concerns/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            
            'update': { method:'PUT' },
            
            'getInformationRequests' : {method: 'GET', url:'api/concerns-for-ccr', isArray: true }
            
        });
    }
})();
